<template>
    <router-view />
</template>

<script>
export default {
    name: 'CommodityPurchaseLayout',
};
</script>

<style scoped></style>
